import channels, { Channel } from '../../../modules/channel/config/channel.config';
import rootConfig from '../../../config/root.config';
import { Data as CategoriesData } from '../../../modules/category/types/categories';
import matchChannel from '../../../common/utils/matchChannel';

type BuildCategoryUrl = ({
  category,
  domain,
  fakeDomainEnabled,
}: {
  category: CategoriesData;
  domain?: string | string[];
  fakeDomainEnabled?: boolean;
}) => string;

function generatePath(category: CategoriesData) {
  const items = [];

  const channelPath = (category.channel && category.channel.path) || rootConfig.main_slug;
  if (channelPath !== null) {
    items.push(channelPath);
  }

  return items.join('/');
}

function buildCategoryDevUrl(category: CategoriesData, channelConfig: Channel) {
  const origin = process.client ? document.location.origin : '';
  const path = generatePath(category);
  return channelConfig.old_type_redirects_dev ? `https://${channelConfig.url}/${category.slug}` : `${origin}/${path}/${category.slug}`;
}

function buildCategoryLiveUrl(category: CategoriesData, channelConfig: Channel) {
  const path = generatePath(category);
  return `https://${channelConfig.domain}/${path}/${category.slug}`;
}

const buildCategoryUrl: BuildCategoryUrl = ({ category, domain, fakeDomainEnabled }) => {
  const { channel } = category;
  const channelPath = (category.channel && category.channel.path) || rootConfig.main_slug;
  const sameChannel = domain ? matchChannel(domain, channel.url) : true;

  let categoryUrl = `/${channelPath}/${category.slug}`;

  if (!sameChannel) {
    // TODO: Change after Content-api channel object will return channel url
    const channelConfig = channels.find((ch) => ch.domain === channel.domain);

    if (channelConfig) {
      const isDev = fakeDomainEnabled;
      categoryUrl = isDev ? buildCategoryDevUrl(category, channelConfig) : buildCategoryLiveUrl(category, channelConfig);
    } else {
      throw Error;
    }
  }
  return categoryUrl;
};

export default buildCategoryUrl;
